import { selectLatestDataset } from '@rsos/components/capstone/common/Map/useDeckGL/Axon/useAxonGLNext';

/**
 * Select Axon data and format them for search.
 */
const selectAxon = state => {
  if (
    state.axon &&
    state.axon.datasets &&
    !Object.keys(state.axon.datasets).length
  ) {
    return null;
  }

  const dataset = selectLatestDataset(state);

  let searchableAxonMarkers = [];
  if (dataset) {
    searchableAxonMarkers = Object.values(dataset).map(ds => ({
      ...ds,
      source: 'axon',
      _badgeNumber: ds.attributes?.officer?.badge_number,
      _lastName: ds.attributes?.officer?.last_name,
    }));
  }

  const formatted = {
    keys: ['_badgeNumber', '_lastName'],
    data: searchableAxonMarkers,
  };

  return formatted;
};

export default selectAxon;
